import React from 'react';
import Page from '../../../layout/Page';
import Activity from './Activity';
import Usage from './Usage';
import { userRoles } from '../../../RoleProtected';

const ExpressPassReport = ({ children, ...props }) => {

    return (
        <Page
            title='ExpressPass'
            tabs
        >
            <Activity tab='Activity' roles={userRoles.viewUsageReports} />
            <Usage tab='Usage' roles={userRoles.viewUsageReports} />
        </Page >
    );
}

export default ExpressPassReport;
